"use client"

import { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { LoadingSpinner } from "@/components/ui/loading-spinner"

const ChartComponent = dynamic(
  () => import('./chart-component'),
  { 
    loading: () => <LoadingSpinner />,
    ssr: false
  }
)

interface DataPoint {
  year: string
  value: number | null
  average: number | null
}

interface AcademicResultsChartProps {
  data: DataPoint[]
  grade: string
  subject?: string
  isMeritValue?: boolean
  schoolName: string
  yAxisLabel?: string
}

export default function AcademicResultsChart(props: AcademicResultsChartProps) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return <LoadingSpinner />
  }

  return <ChartComponent {...props} />
}